import Vue from 'vue'
import SEComp from '../bl-components/bar/main.vue'
import { InitUIParams, InitUIProps, SEBundle, TFEvents } from '../types/types'

const initVue = async (props: InitUIProps) => {
    return new Vue({
        render: (createElement) =>
            createElement(SEComp, {
                props
            })
    }).$mount(props.selector)
}

const init = (initUIParams: InitUIParams) => {
    const bundle: SEBundle = initUIParams.bundle
    const events: TFEvents = initUIParams.events

    return async (props: InitUIProps): Promise<void> => {
        return new Promise((resolve, reject) => {
            events.onceAll(
                ['libs.se'],
                () => {
                    initVue({
                        ...props,
                        store: bundle.store
                    })
                    resolve()
                },
                true
            )
        })
    }
}

export default init
